import { defineAgenda, param } from '@/shared/navigation/core';

export const AIRLINE_TAB_KEYS = ['general', 'extraServices'] as const;

export type AirlineTabKey = (typeof AIRLINE_TAB_KEYS)[number];

/**
 * Agenda detailu letecké společnosti — jeden formulář pro založení i editaci. Bez `airlineId`
 * = založení, s `airlineId` = editace. Otevírá se výběrem v seznamu (`openDetail`), geometrii
 * řídí `layoutMode: 'overlay'`.
 */
export const airlineDetailAgenda = defineAgenda({
  id: 'app.inventory.airline-detail',
  path: 'app/inventory/airline',
  open: {
    airlineId: param.number().optional(),
  },
  state: {
    // Zvolená záložka žije v URL, aby ji obnovil reload i deep-link (ne lokální useState).
    tab: param.enum(AIRLINE_TAB_KEYS).optional(),
  },
  title: 'Letecká společnost',
  icon: 'plane',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
